import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Navigation from "./components/navigation";
import Home from "./components/home";
import UsBirds from "./components/usbirds";
import ImportBirds from "./components/importbirds";
import ForSale from "./components/forsale";
import Admin from "./components/admin";
import Image from "react-bootstrap/Image";
import StoreProvider from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import FlexView from "react-flexview/lib";
import Footer from "./components/atoms/molecules/Footer";
import LandingSpot from "./components/landingspot";
function App() {
  const headerStyle = {
    color: "red",
    textAlign: "center",
    margin: "20px",
    fontFamily: "Impact, Haettenschweiler,Arial Narrow Bold, sans-serif",
    letterSpacing: "5px",
  };

  return (
    <StoreProvider>
      <div className="main">
        <Router>
          <FlexView hAlignContent="center">
            <div className="logo">
              <Image src={require("./images/logo2.png")} style={{}} />
            </div>
          </FlexView>
          <div>
            <Navigation></Navigation>
          </div>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/landingspot" exact component={LandingSpot} />
            <Route path="/home" exact component={Home} />
            <Route path="/usbirds" exact component={UsBirds} />
            <Route path="/importbirds" exact component={ImportBirds} />
            <Route path="/forsale" exact component={ForSale} />
            <Route path="/admin" component={Admin} />
          </Switch>
          <Footer></Footer>
        </Router>
      </div>
    </StoreProvider>
  );
}

export default App;
